import { css, Theme } from '@mui/material'

export const alertContainer = ({ theme }: { theme: Theme }) => css`
  max-width: 100%;
  height: ${theme.spacing(10)};
  background-color: ${theme.palette.blue[50]};
  position: relative;
  padding: 0 ${theme.spacing(2)};
  gap: ${theme.spacing(1)};
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 110;
`

export const badgeContainer = ({ theme }: { theme: Theme }) => css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: ${theme.spacing(3)};
`
